'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'gauge-max';
var width = 512;
var height = 512;
var aliases = ["tachometer-alt-fastest"];
var unicode = 'f626';
var svgPathData = ['M48 256a208 208 0 1 0 416 0 208 208 0 1 0 -416 0zm96 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm48-96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm8 192c0-30.9 25.1-56 56-56 9.4 0 18.3 2.3 26.1 6.4l87.5-65.6c10.6-8 25.6-5.8 33.6 4.8s5.8 25.6-4.8 33.6l-87.5 65.6c.7 3.6 1.1 7.3 1.1 11.2 0 30.9-25.1 56-56 56s-56-25.1-56-56zm88-240a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96 48a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z', 'M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416zM256 0a256 256 0 1 1 0 512 256 256 0 1 1 0-512zm32 112a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM256 408c-30.9 0-56-25.1-56-56s25.1-56 56-56c9.4 0 18.3 2.3 26.1 6.4l87.5-65.6c10.6-8 25.6-5.8 33.6 4.8s5.8 25.6-4.8 33.6l-87.5 65.6c.7 3.6 1.1 7.3 1.1 11.2 0 30.9-25.1 56-56 56zM384 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM112 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm80-64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faGaugeMax = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;